import TaskApi from "../../service/TaskService";
import ProcessApi from "../../service/ProcessService";
import GetAllLeadPartyRequest from "../../service/request/GetAllLeadPartyRequest";
import CompleteTaskRequest from "../../service/request/CompleteTaskRequest";
import GetMyActiveTaskRequest from "../../service/request/GetMyActiveTaskRequest";
import _ from "underscore";

export default {
  name: "AllOngoingProcessListTable",
  props: {
    showSelect: { type: Boolean, required: true }
  },
  data: function() {
    return {
      selectedProcessDefinitionCode: 0,
      leadPartyNameDTOList:[]
    };
  },
  computed: {
    headers() {
      let headers = [
        {
          text: "",
          value: "",
          filterable: false
        },
        {
          text: this.$t("tckn"),
          value: "tckn",
          filterable: true
        },
        {
          text: this.$t("full/Name"),
          value: "fullName",
          filterable: true
        },
        {
          text: this.$t("processDefinition"),
          value: "processDefinition",
          filterable: true
        },
        {
          text: this.$t("processStartDate"),
          value: "processStartDate",
          filterable: true
        },
        {
          text: this.$t("resourceDescription"),
          value: "resourceDescription",
          filterable: false
        },
        {
          text: this.$t("status_"),
          value: "hasNFCPhone",
          filterable: false
        },
        {
          text: this.$t("consultantUnit"),
          value: "assignedUnitCode",
          filterable: false,
          fixed: true
        },
        {
          text: this.$t("investmentConsultant"),
          value: "assignedName",
          filterable: false,
          fixed: true
        },
        {
          text: this.$t("channelInformation"),
          value: "channel",
          filterable: false,
          fixed: true
        },
        {
          text: this.$t("applicationInformation"),
          value: "applicationInformation",
        },
        {
          text: this.$t("meetingPreference"),
          value: "meetingPreference",
          filterable: false
        },
        {
          text: this.$t("appointmentDateTime"),
          value: "appointmentDateTime",
          filterable: false
        }
      ];

      if (this.showSelect) {
        headers.unshift({
          text: "",
          value: "",
          filterable: false
        });
      }

      return headers;
    },
    processDefinitionCodeList: function() {
      return [
        {
          value: 0,
          text: this.$t("all")
        },
        {
          value: 1,
          text: this.$t("videocall")
        },
        {
          value: 2,
          text: this.$t("nfcandvideocall")
        },
        {
          value: 3,
          text: this.$t("selfonboarding")
        }
      ];
    }
  },
  beforeMount() {
    this.getAllByCurrentUserIdAndAssigneeId()
  },
  created() {
    this.PAGE_TYPE = "OngoingProcessList";
  },
  methods: {
    getData() {
      this.refreshing = true;
      const checkedItemIds = this.list.reduce(
        (a, curr) => (curr.checked ? a.concat(curr.id) : a),
        []
      );

      const getAllLeadPartyRequest = new GetAllLeadPartyRequest();
      if (this.selectedProcessDefinitionCode === 1) {
        getAllLeadPartyRequest.processDefinitionCodes = [
          "VIDEO_CALL_PROCESS_V2"
        ];
      } else if (this.selectedProcessDefinitionCode === 2) {
        getAllLeadPartyRequest.processDefinitionCodes = [
          "NFC_AND_VIDEO_PROCESS"
        ];
      } else if (this.selectedProcessDefinitionCode === 3) {
        getAllLeadPartyRequest.processDefinitionCodes = [
          "SELF_ONBOARDING_PROCESS"
        ];
      } else if (this.selectedProcessDefinitionCode === 4) {
        getAllLeadPartyRequest.processDefinitionCodes = [
          "LEAD_APPROVAL_PROCESS"
        ];
      }
      getAllLeadPartyRequest.leadPartyDTO.domainId = this.$store.getters[
        "user"
      ].domainId;
      getAllLeadPartyRequest.leadPartyDTO.tckn =
        this.searchTckn != null && this.searchTckn != ""
          ? this.searchTckn
          : null;
      getAllLeadPartyRequest.assigneeUnitCode = this.searchUnitCode;
      getAllLeadPartyRequest.assignee =
        this.searchAssignedName != null && this.searchAssignedName != ""
          ? this.searchAssignedName
          : null;
      getAllLeadPartyRequest.leadIds =
        this.leadIds.length > 0 ? this.leadIds : null;
      getAllLeadPartyRequest.assigneeId = this.$store.getters["user"].id;
      getAllLeadPartyRequest.currentUserId = this.$store.getters["user"].id;
      getAllLeadPartyRequest.pageSize = this.pageOptions.itemsPerPage;
      getAllLeadPartyRequest.page = this.pageOptions.page - 1;

      ProcessApi.listAllActualProcesses(
        this,
        getAllLeadPartyRequest,
        response => {
          this.list = response.content.content.sort(
            (x, y) => y.showVideoConference - x.showVideoConference
          );
  
          this.list.forEach(item => {
            item.taskId = item.actualProcessTasks[0].taskId;
            item.processId = item.actualProcessTasks[0].processId;
            item.resourceDescription =
              item.actualProcessTasks[0].resourceSetResource.resource.description;
          });

          this.totalItems = response.content.totalElements;
          this.checkPreviouslyCheckedItems(checkedItemIds);
          this.refreshing = false;
        },
        error => {
          console.log(error);
          this.refreshing = false;
        }
      );
    },

    getAllByCurrentUserIdAndAssigneeId() {

      ProcessApi.getAllByCurrentUserIdAndAssigneeId(
        this,
        this.$store.getters["user"].id,
        this.$store.getters["user"].id,
        this.$store.getters["user"].domainId,
        response => {
          if (response != null && response.actualProcessDTOList != null) {
            this.leadPartyNameDTOList = response.actualProcessDTOList.map(this.prepareLeadPartyNameDTO);

          }
        }
      );

    },
    prepareLeadPartyNameDTO: function (item) {
      let prepareLeadPartyNameDTO = {};
      prepareLeadPartyNameDTO.id = item.leadParty.id;
      prepareLeadPartyNameDTO.fullName = item.leadParty.fullName;
      prepareLeadPartyNameDTO.status = item.leadParty.status;
      return prepareLeadPartyNameDTO;
    },
    onClickJoinVideoCall(fullName, tckn, id, processId, primaryContactType) {
      this.$emit(
        "onClickJoinVideoCall",
        fullName,
        tckn,
        id,
        processId,
        primaryContactType
      );
    },
    onClickWaitingToSendApproval(processId, tckn) {
      this.toShowApprovalPage(processId, tckn);
    },
    onClickWaitingToSendPreApprove(processId, tckn) {
      this.toShowApprovalPage(processId, tckn);
    },
    onClickWaitingApproval(processId, tckn) {
      this.toShowApprovalPage(processId, tckn);
    },
    onClickFinalApproval(processId, tckn) {
      this.toShowApprovalPage(processId, tckn);
    },
    onClickRefreshRoom(processId) {
      const getMyActiveTaskRequest = new GetMyActiveTaskRequest();
      getMyActiveTaskRequest.processId = processId;

      TaskApi.getMyActiveTask(
        this,
        getMyActiveTaskRequest,
        response => {
          const completeTaskRequest = new CompleteTaskRequest();
          completeTaskRequest.taskId = response.activeResourceTask.taskId;
          completeTaskRequest.variables = [
            {
              code: "videoCallStatus",
              value: "failed"
            }
          ];
          TaskApi.completeTask(this, completeTaskRequest, () => {
            TaskApi.getMyActiveTask(
              this,
              getMyActiveTaskRequest,
              response => {
                console.log(response);
              },
              error => {
                console.log(error);
              }
            );
            this.getData();
          });
        },
        error => {
          console.log(error);
        }
      );
    },
    onClickSendLink(processId, leadPartyId) {
      this.$emit("onClickSendLink", processId, leadPartyId);
    },
    onClickDropAssignee(processId, leadPartyId) {
      this.$emit("onClickDropAssignee", processId, leadPartyId);
    },
    onClickAddNote(processId) {
      this.$emit("onClickAddNote", processId);
    },
    toShowApprovalPage(processId, tckn) {
      const getMyActiveTaskRequest = new GetMyActiveTaskRequest();
      getMyActiveTaskRequest.processId = processId;

      TaskApi.getMyActiveTask(
        this,
        getMyActiveTaskRequest,
        response => {
          if (response.activeResourceTask.resourceKey === "ShowApproval") {
            this.$router.push({
              name: response.activeResourceTask.resourceKey,
              params: {
                processId: processId,
                tckn: tckn
              }
            });
          } else {
            const completeTaskRequest = new CompleteTaskRequest();
            completeTaskRequest.taskId = response.activeResourceTask.taskId;
            TaskApi.completeTask(this, completeTaskRequest, response => {
              this.$router.push({
                name: response.activeResourceTask.resourceKey,
                params: {
                  processId: processId,
                  tckn: tckn
                }
              });
            });
          }
        },
        error => {
          console.log(error);
        }
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/mixin/AllOngoingProcessListTable.js